import { History, FileText, Ticket as TicketIcon } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { seqDeFolio } from "./constants";
import { fmtTime, esHoyLocal } from "@/lib/datetime";

// Historial de Entregas del día (presentacional puro; deriva las filas de `items`).
export const HistorialModal = ({ historyOpen, setHistoryOpen, items }) => (
  <Dialog open={historyOpen} onOpenChange={setHistoryOpen}>
    <DialogContent className="rounded-none border-white/20 bg-[#0A0A0A] text-white max-w-2xl max-h-[90dvh] overflow-y-auto overflow-x-hidden" data-testid="valet-historial-modal">
      <DialogHeader>
        <DialogTitle className="font-display font-black text-white text-lg flex items-center gap-2"><History className="h-5 w-5 text-[#FFCC00]" /> Historial de Entregas · Hoy</DialogTitle>
        <DialogDescription className="text-white/50">Solicitudes y entregas registradas durante el día.</DialogDescription>
      </DialogHeader>
      {(() => {
        const esHoy = (d) => esHoyLocal(d);
        const hora = (d) => d ? fmtTime(d) : "—";
        const rows = items
          .filter((v) => esHoy(v.solicitado_at) || esHoy(v.entregado_at))
          .sort((a, b) => new Date(b.entregado_at || b.solicitado_at) - new Date(a.entregado_at || a.solicitado_at));
        if (!rows.length) return <p className="text-white/40 text-sm py-8 text-center" data-testid="valet-historial-empty">Aún no hay solicitudes ni entregas registradas hoy.</p>;
        return (
          <div className="max-h-[60vh] overflow-y-auto">
            <table className="w-full text-sm" data-testid="valet-historial-tabla">
              <thead className="text-white/40 text-[10px] uppercase tracking-wider">
                <tr className="border-b border-white/10 text-left">
                  <th className="py-2 pr-3 font-bold">Turno / Folio</th>
                  <th className="py-2 pr-3 font-bold">Vehículo</th>
                  <th className="py-2 pr-3 font-bold">Solicitado</th>
                  <th className="py-2 pr-3 font-bold">Entregado</th>
                  <th className="py-2 font-bold">Incidencia / Cortesía</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((v) => (
                  <tr key={v.id_detalle} className="border-b border-white/5" data-testid={`historial-row-${v.id_detalle}`}>
                    <td className="py-2 pr-3"><span className="font-display font-black text-[#FFCC00]">{seqDeFolio(v.folio_impreso)}</span> <span className="text-[10px] font-mono text-white/40">{v.folio_impreso}</span></td>
                    <td className="py-2 pr-3">{[v.placa, v.marca_modelo].filter(Boolean).join(" · ") || "—"}</td>
                    <td className="py-2 pr-3 font-mono">{hora(v.solicitado_at)}</td>
                    <td className="py-2 pr-3 font-mono">{v.entregado_at ? <span className="text-[#10B981]">{hora(v.entregado_at)}</span> : <span className="text-white/40">Pendiente</span>}</td>
                    <td className="py-2 text-xs" data-testid={`historial-nota-${v.id_detalle}`}>
                      {v.es_cortesia && <span className="inline-flex items-center gap-1 text-[#A78BFA] font-bold mb-0.5"><TicketIcon className="h-3 w-3" /> Cortesía: {v.motivo_cortesia || "—"}</span>}
                      {v.nota_incidencia && <p className="text-[#38BDF8] flex items-start gap-1 leading-snug"><FileText className="h-3 w-3 mt-0.5 shrink-0" /> {v.nota_incidencia}</p>}
                      {!v.es_cortesia && !v.nota_incidencia && <span className="text-white/25">—</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })()}
    </DialogContent>
  </Dialog>
);

export default HistorialModal;
